import React from "react"

export const ElectricityIcon: React.FC = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.25171 3.1276C8.31296 3.14194 8.35668 3.19707 8.35674 3.25998V6.66493H9.84033C10.031 6.66493 10.1565 6.86392 10.0742 7.03599L7.53257 12.3537C7.46556 12.4363 7.33545 12.4215 7.28875 12.326L7.2739 12.2956V8.89149H5.71768C5.52572 8.89149 5.40033 8.69014 5.48501 8.51787L8.09894 3.20009C8.12678 3.1436 8.19037 3.11334 8.25171 3.1276Z"
        fill="#37474F"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.17576 0.00911458L8.35934 0.0199653C10.2498 0.150924 11.8959 0.925675 13.2627 2.29253C14.7675 3.79738 15.5556 5.64106 15.5556 7.77778L15.546 8.17578C15.4538 10.1436 14.6736 11.8521 13.2627 13.263C11.8959 14.6299 10.2498 15.4046 8.35934 15.5356L8.17576 15.5464L7.77561 15.5556C5.63994 15.555 3.79708 14.7673 2.29284 13.263C0.926045 11.8961 0.151339 10.25 0.0203982 8.35938L0.00954808 8.17578L0 7.77778C5.60253e-08 5.64104 0.788075 3.79739 2.29284 2.29253C3.79709 0.788218 5.63993 0.00054126 7.77561 0L8.17576 0.00911458ZM7.77778 1.18142C5.96966 1.18143 4.42799 1.83359 3.14132 3.11415L3.13828 3.11719L3.13524 3.12066L3.13177 3.1237C2.06828 4.28548 1.28442 5.8649 1.19047 7.45877V7.46224L1.18179 7.77474V7.77778C1.1818 9.59234 1.83893 11.1381 3.1283 12.4275C4.41766 13.7169 5.96334 14.3741 7.77778 14.3741C9.59221 14.3741 11.1379 13.7169 12.4273 12.4275C13.6356 11.2191 14.2899 9.78496 14.3668 8.11458V8.11198L14.3738 7.77995V7.77778C14.3738 6.07898 13.5592 4.367 12.4273 3.12847L12.4247 3.12543L12.4216 3.12326L12.182 2.89323L12.1794 2.89106C11.0237 1.83371 9.67098 1.25996 8.1137 1.18837H8.11109L7.77995 1.18142H7.77778Z"
        fill="#37474F"
      />
    </svg>
  )
}
